import { createEntitiesReducer } from 'app/lib/betting/betting-entities';
import {
  APPLY_FAVORITES_STATE,
  SUBSCRIBE_TO_FAVORITES,
  UNSUBSCRIBE_FROM_FAVORITES,
} from 'app/modules/PrematchFavorites/actions';

export default createEntitiesReducer({
  REQUEST_ACTION: SUBSCRIBE_TO_FAVORITES,
  TRIGGER_ACTION: APPLY_FAVORITES_STATE,
  CLEANUP_ACTION: UNSUBSCRIBE_FROM_FAVORITES,
});
